import { render, staticRenderFns } from "./RegistrationFlexibility.vue?vue&type=template&id=cdc3609a&scoped=true"
import script from "./RegistrationFlexibility.vue?vue&type=script&lang=js"
export * from "./RegistrationFlexibility.vue?vue&type=script&lang=js"
import style0 from "./RegistrationFlexibility.vue?vue&type=style&index=0&id=cdc3609a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc3609a",
  null
  
)

export default component.exports